import React, { useState, useEffect, FC } from "react";

type TProps = {
  recordsCount: number;
  pageSize: number;
  setPageNumber: (num: number) => void;
};

const DataTablePagination: FC<TProps> = ({ recordsCount, pageSize, setPageNumber }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [canGoBack, setCanGoBack] = useState(false);
  const [canGoNext, setCanGoNext] = useState(true);

  useEffect(() => {
    setPageNumber(currentPage);
  }, [currentPage]);

  const onNextPage = () => setCurrentPage(currentPage + 1);

  const onPrevPage = () => setCurrentPage(currentPage - 1);

  const onPageSelect = (pageNo: number) => setCurrentPage(pageNo);

  const noOfPages = Math.ceil(recordsCount / pageSize);

  useEffect(() => {
    if (noOfPages === currentPage) {
      setCanGoNext(false);
    } else {
      setCanGoNext(true);
    }
    if (currentPage === 1) {
      setCanGoBack(false);
    } else {
      setCanGoBack(true);
    }
  }, [noOfPages, currentPage]);

  return noOfPages > 1 ? (
    <div className="pagination d-flex flex-row align-items-center justify-content-between">
      <div className="pagination__total text-dark">
        Showing {pageSize} of {recordsCount}
      </div>
      <div className="pagination__actions d-flex flex-row align-items-center">
        {canGoBack && (
          <button type="button" className="btn btn-prev me-2" onClick={() => onPrevPage()}>
            Previous
          </button>
        )}
        <div className="pagination__actions__pages">
          {Array(Math.floor(recordsCount / pageSize))
            .fill(0)
            .map((_item, index) => (
              <button
                key={`pagination_${index}`}
                type="button"
                className={`btn ${index + 1 === currentPage ? "btn--active" : ""}`}
                onClick={() => onPageSelect(index + 1)}
              >
                {index + 1}
              </button>
            ))}
        </div>
        {canGoNext && (
          <button type="button" className="btn btn-next ms-2" onClick={() => onNextPage()}>
            Next
          </button>
        )}
      </div>
    </div>
  ) : null;
};

export default DataTablePagination;
